'use client'

import { HeroBanner } from '@/components/common/home/hero-banner'
import { HeroBannerShell } from '@/components/common/home/hero-banner-shell'
import { TBannerSlide } from '@/types/home'
import { useEffect, useState } from 'react'

type Props = {
  slides: TBannerSlide[]
  isMobile?: boolean
  homeType?: 'nam' | 'nu' | 'chung'
}

/**
 * Progressive enhancement wrapper for mobile hero banner.
 * - SSR + before hydration: renders HeroBannerShell (native <img>, zero JS, fast LCP)
 * - After hydration: swaps to HeroBanner (Carousel with autoplay)
 */
export function HeroBannerProgressive({ slides, isMobile, homeType }: Props) {
  const [hydrated, setHydrated] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- deliberate post-hydration swap from the zero-JS shell to the interactive carousel (LCP optimization, see file header comment)
    setHydrated(true)
  }, [])

  if (!hydrated) {
    return <HeroBannerShell slides={slides} />
  }

  return <HeroBanner slides={slides} isMobile={isMobile} homeType={homeType} />
}
